import { render, staticRenderFns } from "./Swallow.vue?vue&type=template&id=dcbe5662&scoped=true&"
import script from "./Swallow.vue?vue&type=script&lang=js&"
export * from "./Swallow.vue?vue&type=script&lang=js&"
import style0 from "./Swallow.vue?vue&type=style&index=0&id=dcbe5662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe5662",
  null
  
)

export default component.exports